module.exports = __webpack_public_path__ + "static/desarrollo-app-2dc563ee8713a4a75a241684dc18ccaf.svg";